import mixpanel from "mixpanel-browser";

let isInitialized = false;

// Initialize Mixpanel
const initializeMixpanel = () => {
  const token = process.env.REACT_APP_MIXPANEL_TOKEN;

  if (!token) {
    console.warn("Mixpanel not initialized");
    return false;
  }

  try {
    mixpanel.init(token, {
      debug: true,
      autocapture: {
        pageview: "full-url",
        click: false,
        input: false,
        scroll: false,
        submit: false,
      },
      track_pageview: true,
      persistence: "localStorage",
    });
    isInitialized = true;

    // Check if user is already logged in and identify them
    // const userData = localStorage.getItem("credential");
    // if (userData) {
    //   const { user_id, username } = JSON.parse(userData);
    //   identifyUser(user_id, { user_id, username });
    // }

    return true;
  } catch (error) {
    return false;
  }
};

// Identify a user in Mixpanel
const identifyUser = (user_id, userProperties = {}) => {
  if (!isInitialized) {
    console.warn("Mixpanel not initialized");
    return false;
  }

  try {
    // Identify the user with their unique ID
    // const alreadyAliased = localStorage.getItem('mixpanel_aliased');
    // if (!alreadyAliased) {
    //   mixpanel.alias(user_id);
    //   localStorage.setItem('mixpanel_aliased', 'true');
    // }
    mixpanel.identify(user_id);

    // Set user properties
    mixpanel.people.set({
      $name: userProperties.username,
      $user_id: userProperties.user_id,
    });

    return true;
  } catch (error) {
    console.error("Error identifying user in Mixpanel:", error);
    return false;
  }
};

// Track login event
const trackLogin = (userData) => {
  if (!isInitialized) {
    console.warn("Mixpanel not initialized");
    return false;
  }

  try {
    // Identify the user first
    identifyUser(userData.user_id, {
      user_id: userData.user_id,
      username: userData.username,
    });

    // Track the login event
    mixpanel.track("User Login", {
      user_id: userData.user_id,
      timestamp: new Date().toISOString(),
      login_method: "email",
      success: true,
    });

    return true;
  } catch (error) {
    console.error("Error tracking login in Mixpanel:", error);
    return false;
  }
};

// Reset user identification
const resetUser = () => {
  if (!isInitialized) {
    console.warn("Mixpanel not initialized");
    return false;
  }

  try {
    mixpanel.reset();
    return true;
  } catch (error) {
    console.error("Error resetting user in Mixpanel:", error);
    return false;
  }
};

// Track feature usage
const trackFeatureUsage = (featureName, properties = {}) => {
  if (!isInitialized) {
    return;
  }

  try {
    mixpanel.track("Feature Used", {
      feature_name: featureName,
      ...properties,
      timestamp: new Date().toISOString(),
    });
  } catch (error) {}
};

// Track feature failure
const trackFeatureFailure = (featureName, error, properties = {}) => {
  if (!isInitialized) {
    return;
  }

  try {
    mixpanel.track("Feature Failed", {
      feature_name: featureName,
      error_message: error?.message || error,
      ...properties,
      timestamp: new Date().toISOString(),
    });
  } catch (error) {}
};

// Initialize on import
initializeMixpanel();

export {
  identifyUser,
  resetUser,
  trackLogin,
  trackFeatureUsage,
  trackFeatureFailure,
};
